import React from 'react'
import injectSheet from 'react-jss'
import styles from './works-header.styles'
import Button from 'pobble-components/dist/button'
import PlusIcon from 'react-icons/lib/fa/plus'

const WorksHeader = ({
  classes,
  title,
  count,
  onOpenAddWorkDialog,
  canUpdate,
  isStudentActive
}) => (
  <header className={classes.container}>
    <div>
      <h1 className={classes.title}>{title}</h1>
      <span className={classes.count}>
        {count} piece{count > 1 ? 's' : ''} of work attached
      </span>
    </div>
    {isStudentActive && canUpdate && (
      <Button
        tall
        action={() => {
          onOpenAddWorkDialog()
        }}>
        <PlusIcon /> Add work
      </Button>
    )}
  </header>
)

export default injectSheet(styles)(WorksHeader)
